import { selectionOutcomeTypeMapper } from "../selectionOutcomeTypeMapper";
export var getSelectionSide = function (selection) {
    return selection.outcomeType && selectionOutcomeTypeMapper[selection.outcomeType];
};
//# sourceMappingURL=getSelectionSide.js.map